import { useMural } from 'modules/jogador/mural/useMural';
import { PillTabs } from 'shared/components/ui/PillTabs';
import { Button } from 'shared/components/ui/Button';
import { PostCard } from 'modules/jogador/mural/components/PostCard';
import { CreateRachaCard } from 'modules/jogador/mural/components/CreateRachaCard';
import { MURAL_TABS } from 'modules/jogador/mural/content';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { SkeletonPostCard } from 'shared/components/ui/Skeleton';

export function MuralPage() {
  const {
    activeTab,
    setActiveTab,
    posts,
    isLoading,
    error,
    joinedPostIds,
    joinPost,
    isCreatingRacha,
    rachaForm,
    updateRachaForm,
    openCreateRacha,
    cancelCreateRacha,
    publishRacha,
  } = useMural();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold text-ink">Mural</h1>
          <p className="text-sm text-ink-secondary">Arena Praia Norte</p>
        </div>
        {!isCreatingRacha && <Button variant="ghost" onClick={openCreateRacha}>+ Criar racha</Button>}
      </div>

      <div className="mt-4">
        <PillTabs options={[...MURAL_TABS]} value={activeTab} onChange={setActiveTab} />
      </div>

      {isCreatingRacha && (
        <div className="mt-6">
          <CreateRachaCard
            form={rachaForm}
            onChange={updateRachaForm}
            onPublish={publishRacha}
            onCancel={cancelCreateRacha}
          />
        </div>
      )}

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando mural..."
        skeleton={
          <div className="mt-6 flex flex-col gap-4">
            <SkeletonPostCard />
            <SkeletonPostCard withAction={false} />
            <SkeletonPostCard withAction={false} />
          </div>
        }
      >
        <div className="mt-6 flex flex-col gap-4">
          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              joined={joinedPostIds.includes(post.id)}
              onJoin={() => joinPost(post.id)}
            />
          ))}
        </div>
      </AsyncSection>
    </section>
  );
}
